// 主题样式
import themes from './theme.json'

export function addColor (init){
    const theme = localStorage.theme
    const {lsjz,gctj,zxjz,qgndtj,obj={}} = themes
  
    // 1.localStorage.theme 不存在默认黑色 2.存在并且刷新页面不改变主题 3.存在并且点切换才改变主题
        if(init == 'lsjz'){
            localStorage.setItem('theme','lsjz')
            Object.assign(obj,lsjz)
        } else if(init == 'gctj'){
            localStorage.setItem('theme','gctj')
            Object.assign(obj,gctj)
        } else if(init == 'zxjz'){
            localStorage.setItem('theme','zxjz')
            Object.assign(obj,zxjz)
        } else if(init == 'qgndtj'){
            localStorage.setItem('theme','qgndtj')
            Object.assign(obj,qgndtj)
        }
    // html 添加主题样式
    for (const key in obj) {
        document.documentElement.style.setProperty(key, obj[key]);
    }
}

